<template>
  <div class="brainMachine">
    <a-card class="tab">
      <a-tabs default-active-key="4" @change="callback">
        <a-tab-pane key="4" tab="专注与放松"></a-tab-pane>
        <a-tab-pane key="6" tab="神经反馈"></a-tab-pane>
      </a-tabs>
      <a-button type="primary" @click="importBrain.visible = true" class="uplod">批量导入</a-button>
    </a-card>
    <a-card style="margin-top: 15px">
      <div @keyup.enter="getList(1)">
        <a-form-model layout="inline">
          <a-form-model-item label="平板编码">
            <a-input placeholder="请输入" allow-clear v-model.trim="searchForm.padSN" />
          </a-form-model-item>
          <a-form-model-item label="头环编码">
            <a-input placeholder="请输入" allow-clear v-model.trim="searchForm.brainMachineRingSN" />
          </a-form-model-item>
          <a-form-model-item label="头环标签">
            <a-input placeholder="请输入" allow-clear v-model.trim="searchForm.brainMachineRingName" />
          </a-form-model-item>
          <a-form-model-item label="所属客户">
            <a-input placeholder="请输入" allow-clear v-model.trim="searchForm.customer" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="getList(1)">查询</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="addBrain()" icon="plus">录入设备</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div style="overflow: auto; margin-top: 15px">
        <a-table
          style="min-width: 800px"
          :columns="columns"
          @change="handleTableChange"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <div slot="headring" slot-scope="text">
            <div class="table-td" v-for="item in text.brainMachineRings">
              {{ item.name + " : " + item.sn }}
            </div>
          </div>
          <div slot="action" class="action" slot-scope="text">
            <a @click="getModel(text)">编辑</a>
            <a-popconfirm title="确定删除？" @confirm="deleteitem(text)">
              <a class="red">删除</a>
            </a-popconfirm>
          </div>
        </a-table>
      </div>
    </a-card>

    <!-- 录入设备 -->
    <a-modal v-model="enter.visible" :title="enter.tit" @ok="Submit" @cancel="cancelSubmit"
             :confirmLoading="enter.loading">
      <a-form-model ref="addForm" style="max-height: 500px; overflow-y: auto" :labelCol="{ span: 6 }"
                    :wrapperCol="{ span: 16 }" :model="enter.form" :rules="enter.rules">
        <a-form-model-item label="平板编码" prop="padSN">
          <a-input v-model.trim="enter.form.padSN" :maxLength="35" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="头环标签/编码" :required="true">
          <div style="position: relative">
            <div v-for="(item, index) in enter.form.brainMachineRings" :key="index"
                 style="display: flex; line-height: 1.5; margin: 3px 0 10px; position: relative">
              <a-input v-model.trim="item.name" :maxLength="35" placeholder="请输入头环标签" />
              <span style="margin: 0 10px">~</span>
              <a-input v-model.trim="item.sn" :maxLength="35" placeholder="请输入头环编码" />
              <a-icon v-if="index > 0" @click="brainMachineRingsMinus(index)" type="minus-circle" class="ring-icon" />
            </div>
            <a-icon @click="brainMachineRingsAdd" type="plus-circle" class="ring-icon" />
          </div>
        </a-form-model-item>

        <a-form-model-item label="所属客户" prop="customer">
          <a-input v-model.trim="enter.form.customer" :maxLength="35" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model.trim="enter.form.remark" type="textarea" :maxLength="500" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 批量导入 -->
    <a-modal width="600px" title="批量导入" :centered="true" v-model="importBrain.visible" @cancel="importBrainCancel"
             :footer="null">
      <a-spin :spinning="importBrain.confirmLoading">
        <a-divider orientation="left">数据模板下载</a-divider>
        <p style="text-align: center">
          <a :href="$data._templatePath + '/template/excel/脑机设备导入模板.xlsx'">点击下载模板</a>
        </p>
        <a-divider orientation="left">批量导入设备</a-divider>
        <a-upload-dragger name="excelfile" class="update-students" :remove="handleRemove" :before-upload="beforeUpload"
                          :fileList="importBrain.fileList" accept=".xlsx,.xls">
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">单击或拖动文件到此区域上传</p>
        </a-upload-dragger>
        <p style="text-align: center; margin: 20px 0">
          <a-button @click="uploadHandleChange" type="primary">导入数据</a-button>
        </p>
        <p style="text-align: center">温馨提示：除备注外均为必填信息，请按模板认真填写否则无法导入</p>
        <div style="text-align: center" v-if="importBrain.errorInfo.errorCount > 0">
          <a-divider orientation="left">错误数据</a-divider>
          <!-- <p style="color: red">{{ importBrain.errorInfo }}</p> -->
          <p>
            本次应导入数据{{ importBrain.errorInfo.errorCount + importBrain.errorInfo.successCount }}条， 成功<em
            :class="importBrain.errorInfo.successCount > 0 ? 'greenEm' : ''">{{
              importBrain.errorInfo.successCount
            }}</em
          >条， 失败<span
            :class="importBrain.errorInfo.errorCount > 0 ? 'redSpan' : ''">{{ importBrain.errorInfo.errorCount }}</span
          >条
          </p>
          <p>
            <a download="批量导入学生错误数据" @click="downError()">点击下载错误数据</a>
          </p>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";
import xlsx from "xlsx-js-style";

const columns = [
  { title: "平板编码", dataIndex: "padSN" },
  { title: "头环 (标签：编码)", scopedSlots: { customRender: "headring" } },
  { title: "所属客户", dataIndex: "customer", width: 150 },
  { title: "备注", dataIndex: "remark", width: 200, ellipsis: true },
  { title: "更新时间", dataIndex: "updateTime", sorter: true },
  { title: "操作", scopedSlots: { customRender: "action" }, align: "center" },
];

export default {
  data() {
    return {
      currentType: 4,
      searchForm: {
        padSN: "",
        brainMachineRingSN: "",
        brainMachineRingName: "",
        customer: "",
        IsDesc: true,
      },
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      enter: {
        tit: "录入设备",
        visible: false,
        loading: false,
        form: {
          padSN: "",
          brainMachineRings: [{ name: "", sn: "" }],
          customer: "",
          remark: "",
        },
        rules: {
          padSN: [
            { required: true, message: "请输入平板编码", trigger: "blur", whitespace: true },
            { min: 2, max: 35, message: "平板编码长度 2 到 35 个字符", trigger: "blur" },
          ],
          customer: [
            { required: true, message: "请输入所属客户", trigger: "blur", whitespace: true },
            { min: 2, max: 35, message: "所属客户长度 2 到 35 个字符", trigger: "blur" },
          ],
        },
      },
      //批量导入
      importBrain: {
        visible: false,
        confirmLoading: false,
        forceUpdate: false, // 是否强制更新
        authorization: "Bearer " + localStorage.getItem("token"),
        fileList: [],
        errorInfo: {},
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    callback(e) {
      this.currentType = e;
      this.getList(1);
    },
    handleTableChange(pagination, filters, sorter) {
      if (sorter.order == "ascend") {
        this.searchForm.IsDesc = true;
        this.getList(1);
      } else if (sorter.order == "descend") {
        this.searchForm.IsDesc = false;
        this.getList(1);
      } else {
        this.searchForm.IsDesc = undefined;
      }
    },
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        type: this.currentType,
        IsDesc: true,
        ...this.searchForm,
      };
      this.tableRelevant.tableLoading = true;
      this.$http.Brain.getBrainMachineList(params, '2.0').then((res) => {
        const { data } = res;
        this.tableRelevant.tableDataSource = data.items;
        this.tableRelevant.tablePagination.total = data.totalCount;
        this.tableRelevant.tablePagination.current = data.pageIndex;
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    addBrain() {
      this.enter.tit = "录入设备";
      this.enter.visible = true;
    },
    getModel(text) {
      this.enter.tit = "编辑设备";
      this.$http.Brain.getModel({ id: text.id }).then((res) => {
        const { data } = res;
        this.enter.form = {
          padSN: data.padSN,
          brainMachineRings: data.brainMachineRings,
          customer: data.customer,
          remark: data.remark,
          id: data.id,
        };
      }).finally(() => {
        this.enter.visible = true;
      });
    },
    deleteitem(text) {
      let formData = new FormData();
      formData.append("ids", [text.id]);
      this.$http.Brain.deleteDevice(formData).then((res) => {
        const { message } = res;
        this.$message.success(message);
        this.getList(1);
      });
    },

    Submit() {
      this.$message.destroy();
      const ringsFilter = this.enter.form.brainMachineRings.filter((f) => !(f.sn.trim() && f.name.trim()));
      if (ringsFilter.length) {
        this.$message.warning("请输入头环标签/编码");
        return;
      }
      if (new Set(this.enter.form.brainMachineRings.map((m) => m.sn)).size < this.enter.form.brainMachineRings.length) {
        this.$message.warning("头环编码不能重复");
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let params = {
            type: this.currentType,
            ...this.enter.form,
            Version: '2.0',
            brainMachineRings: this.enter.form.brainMachineRings.map((m) => {
              let sn = m.sn.toUpperCase();
              if (sn.indexOf(":") === -1) {
                sn = sn.replace(/(?=\B(\w{2})+$)/g, ":");
              }
              return {
                name: m.name,
                sn,
              };
            }),
          };
          if (this.enter.tit == "编辑设备") {
            this.edit(params);
          } else {
            this.add(params);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    add(params) {
      this.enter.loading = true;
      this.$http.Brain.addDevice(params).then((res) => {
        const { message } = res;
        this.cancelSubmit();
        this.$message.success(message);
        this.getList();
      }).finally(() => {
        this.enter.loading = false;
      });
    },
    edit(params) {
      this.enter.loading = true;
      this.$http.Brain.editDevice(params).then((res) => {
        const { message } = res;
        this.cancelSubmit();
        this.$message.success(message);
        this.getList();
      }).finally(() => {
        this.enter.loading = false;
      });
    },
    cancelSubmit() {
      this.enter.visible = false;
      this.$refs.addForm.resetFields();
      this.enter.form = {
        padSN: "",
        brainMachineRings: [{ name: "", sn: "" }],
        customer: "",
        remark: "",
      };
    },

    //批量导入
    beforeUpload(file, fileList) {
      this.importBrain.fileList = [file];
      event.preventDefault();
      event.stopPropagation();
      return false;
    },
    importBrainCancel() {
      this.importBrain.forceUpdate = false;
      this.importBrain.errorInfo = {};
      this.importBrain.fileList = [];
    },
    handleRemove(file) {
      const index = this.importBrain.fileList.indexOf(file);
      const newFileList = this.importBrain.fileList.slice();
      newFileList.splice(index, 1);
      this.importBrain.fileList = newFileList;
    },
    uploadHandleChange() {
      this.$message.destroy();
      if (!this.importBrain.fileList.length) {
        this.$message.error("请选择文件");
        return;
      }
      const form = new FormData();
      form.append("excelfile", this.importBrain.fileList[0]);
      this.importBrain.confirmLoading = true;
      this.$http.Brain.importDeviceData(form, '2.0').then((res) => {
        this.$message.success(message);
        this.importBrain.fileList = [];
        this.importBrain.visible = false;
        this.importBrain.errorInfo = {};
        this.getList(1);
      }).catch(e => {
        this.importBrain.errorInfo = e.data;
        if (e.data.successCount > 0) {
          this.getList(1);
        }
      }).finally(() => {
        this.importBrain.confirmLoading = false;
      });
    },
    downError() {
      const arr = [["设备类型", "平板编码", "头环 (标签 | 编码)", "所属客户", "备注 (选填)", "错误信息"]].concat(
        this.importBrain.errorInfo.errorList.map((f) => [f.typeStr, f.padSN, f.brainMachineRingsStr, f.customer, f.remark, f.errorMessage]),
      );

      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new();
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet(arr);
      // 设置列宽
      const cols = [];
      // 设置内容样式
      Object.keys(worksheet).forEach(f => {
        if (typeof worksheet[f] !== "object") {
          return;
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: "000000" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });
      // 设置表头样式
      arr[0].forEach((f, i) => {
        const ex = xlsx.utils.encode_cell({ r: 0, c: i });
        worksheet[ex].s = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex].v === "错误信息" ? "FF0000" : "000000" },
          },
          fill: {
            fgColor: { rgb: "eeeeeeff" }, // 背景
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } }, // 上边框
            bottom: { style: "thin", color: { rgb: "000000" } }, // 下边框
            left: { style: "thin", color: { rgb: "000000" } }, // 左边框
            right: { style: "thin", color: { rgb: "000000" } }, // 右边框
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
        // 设置列宽
        cols.push({ wpx: worksheet[ex].v === "错误信息" ? 250 : 120 });
      });
      // 设置列宽
      worksheet["!cols"] = cols;
      // 设置行高
      worksheet["!rows"] = arr.map((m, i) => ({ hpt: i > 0 ? 30 : 23 }));
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      // 将工作簿导出为 Excel 文件
      xlsx.writeFile(workbook, "导入设备错误数据.xlsx");
    },
    brainMachineRingsAdd() {
      this.enter.form.brainMachineRings.push({ name: "", sn: "" });
    },
    brainMachineRingsMinus(index) {
      this.enter.form.brainMachineRings.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.tan {
  position: relative;
}

.uplod {
  position: absolute;
  top: 35px;
  right: 35px;
}

.tab .ant-card-body {
  padding-bottom: 0;
}

em {
  font-style: normal;
}

.greenEm {
  font-style: normal;
  color: green;
}

.redSpan {
  color: #f00;
}

.table-td {
  &:not(:last-child) {
    padding-bottom: 16px;
  }
}

.ring-icon {
  cursor: pointer;
  position: absolute;
  top: 9px;
  right: -24px;
}
</style>
